import type { LinkToCohortPageSignature } from '@efdigital/ll-addon-content/types/components/parts/link-to-cohort-page';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { array } from '@ember/helper';
import { LinkTo } from '@ember/routing';

const LinkToCohortPage: TemplateOnlyComponent<LinkToCohortPageSignature> =
  <template>
    <LinkTo
      @route="programs.program.cohort.content.page"
      @models={{array @program.id @cohort.id @page.id}}
      class="nav-link"
      ...attributes
    >{{yield}}</LinkTo>
  </template>;

export { LinkToCohortPage };
